var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMail = function SvgIconMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.722,
    height: 24.299,
    viewBox: "0 0 29.722 24.299",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M613.163,1527.1a3.373,3.373,0,0,0-3.363,3.363v17.573a3.373,3.373,0,0,0,3.363,3.363h23a3.373,3.373,0,0,0,3.363-3.363v-17.573a3.373,3.373,0,0,0-3.363-3.363h-23m0,1.345h23a1.992,1.992,0,0,1,2.018,2.018v.042l-13.537,13.536L611.1,1530.505v-.042a2.028,2.028,0,0,1,2.06-2.018m-2.06,3.994,6.979,6.979L611.1,1546.4v-13.957m27.073,0v13.7l-6.852-6.852,6.852-6.852m-7.819,7.819,7.819,7.819h0a1.992,1.992,0,0,1-2.018,2.018h-23a2.044,2.044,0,0,1-2.018-1.808l7.9-7.9,5.129,5.129a.712.712,0,0,0,.967,0l5.213-5.255Z",
    transform: "translate(-609.8 -1527.1)",
    fill: "#545454"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_mail.fa19df87.svg";
export { ForwardRef as ReactComponent };